import i18n from "../i18n";
import ValidationResult from "../interfaces/api/validation-result";
import CleaningZone from "../interfaces/robot/rooms/cleaning-zone";
import TeachAndRepeatZonePath from "../interfaces/robot/rooms/teach-and-repeat-zone-path";
import { isPointInsidePolygon } from "./zone-validation";

export const validateRepeatPath = (
  repeatPath: TeachAndRepeatZonePath,
  cleaningZone: CleaningZone,
): ValidationResult[] => {

  const errors: ValidationResult[] = [];

  //at least 2 points
  if (repeatPath.path.length < 2) {
    errors.push({ isValid: false, error: i18n.t("validation-error-repeat-path-empty") });
  }

  // any pathpoint outside of the zone
  if (
    repeatPath.path.some(
      (pt) =>
        !isPointInsidePolygon(
          cleaningZone.points.map((czPt) => czPt.point),
          pt,
        ),
      )
    ) {
    errors.push({ isValid: false, error: i18n.t("validation-error-repeat-path-point-outside-zone") });
  }

  // start position not equal first path point
  const startPosition = [
    cleaningZone.startPosition?.coordinateX || 0,
    cleaningZone.startPosition?.coordinateY || 0
  ]
  const path0 = [
    repeatPath.path[0].coordinateX || 0,
    repeatPath.path[0].coordinateY || 0
  ];
  if (!pointsClose(path0, startPosition)){
    errors.push({isValid: false, error: i18n.t("validation-error-repeat-path-start-position-unequal")});
  }

  return errors;
};

const pointsClose = (a: number[], b: number[]) => {

  if (!Array.isArray(a) || !Array.isArray(b)) return false;
  if (a.length !== b.length) return false;

  return a.every((value, index) =>
    Math.abs(value - b[index]) <= 1e-6
  )
}
